import { AUTH_SIGNUP_URL_PRICING } from '../../constant/auth'
import PricingForm from '../pricingForm'

interface IProps {
  isLoggedIn: boolean
}

export default function PricingSection(props: IProps) {
  const { isLoggedIn } = props

  return (
    <div className="relative flex justify-center items-center overflow-hidden md:pb-8 pb-4 h-full w-full bg-black">
      {/* <div className="h-full min-h-[600px] w-[1400px] flex absolute top-0 left-0 justify-center items-center ">
        <div className=" w-full h-full absolute left-0 top-0 bg-black bg-opacity-80 backdrop-filter-[30] backdrop-blur-sm"></div>
      </div> */}
      {isLoggedIn ? <PricingForm {...props} /> : <AuthPricingCard />}
    </div>
  )
}

const options = [
  {
    plan: '7-days subscription',
    price: '$14.99/Week',
  },
  {
    plan: 'Monthly subscription',
    price: '$20.00/Month',
  },
  {
    plan: 'Yearly subscription',
    price: '$99.99/Year',
  },
]

const AuthPricingCard = () => {
  return (
    <div className="bg-white rounded-lg p-5 max-w-[528px] mt-8">
      <h4 className="text-2xl font-rubikBold mb-2">Trial period is over</h4>
      <span className="text-base">
        Your trial period is over Subscribe and purchase a plan to keep streaming
      </span>
      <ul className="my-8">
        {options.map((option, index) => (
          <li key={index} className="flex justify-between bg-[#F2F2F2] p-4 my-1 rounded-lg">
            <span className="text-sm font-rubikMedium">{option.plan}</span>
            <span className="text-sm font-rubikMedium">{option.price}</span>
          </li>
        ))}
      </ul>
      <a
        href={AUTH_SIGNUP_URL_PRICING}
        className="h-12 flex items-center justify-center rounded-lg bg-cyan w-full font-rubikSemiBold text-white text-lg hover:bg-darkBlueOpacity3"
      >
        Sign Up to Continue
      </a>
      <div className="logos mt-2 mb-4">
        <img className="w-auto h-4" src={'/icons/amember/mastercard.svg'} alt={'mastercard'} />
        <img className="w-auto h-4" src={'/icons/amember/visa-color.svg'} alt={'visa'} />
        <img
          className="w-auto h-4"
          src={'/icons/amember/american-express-full.svg'}
          alt={'american-express'}
        />
        <img className="w-auto h-4" src={'/icons/amember/paypal.svg'} alt={'paypal'} />
        <img className="w-auto h-4" src={'/icons/amember/bitcoin.svg'} alt={'bitcoin'} />
        Crypto
      </div>
    </div>
  )
}
